import styled from 'styled-components';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import { H2 } from 'UIComponents/elements/headings';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UISearchableSelectInput from 'UIComponents/input/UISearchableSelectInput';
import UITextArea from 'UIComponents/input/UITextArea';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledHeader = styled.p.withConfig({
  displayName: "RequestSeatModal__StyledHeader",
  componentId: "sc-1b2pheq-0"
})(["font-weight:500;margin-bottom:0;"]);
export const RequestSeatModal = ({
  modalType,
  handleConfirm,
  onClose,
  requestSeatText,
  setRequestSeatText,
  selectableSeatOptions,
  setRequestSeatHandler,
  showSeatSelector
}) => {
  return /*#__PURE__*/_jsxs(UIModal, {
    width: 450,
    "data-test-id": `admin-only-modal-${modalType}-new`,
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: () => onClose()
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `upgrades.requestSeatModal.title`
        })
      })]
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsxs(UIFlex, {
        direction: "column",
        justify: "between",
        align: "center",
        className: "m-bottom-4",
        children: [/*#__PURE__*/_jsx(UIIllustration, {
          name: "lock",
          className: "m-bottom-4",
          height: 60
        }), /*#__PURE__*/_jsx(StyledHeader, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.requestSeatModal.body.title"
          })
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.requestSeatModal.body.subtitle"
        })]
      }), showSeatSelector && selectableSeatOptions.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(StyledHeader, {
          className: "m-bottom-1",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.requestSeatModal.seatInputSelect.title"
          })
        }), /*#__PURE__*/_jsx(UISearchableSelectInput, {
          "data-test-id": `admin-only-modal-${modalType}-new-seat-selector`,
          className: "m-bottom-4",
          onChange: setRequestSeatHandler,
          options: selectableSeatOptions,
          defaultValue: selectableSeatOptions ? selectableSeatOptions[0].value : ''
        })]
      }), /*#__PURE__*/_jsx(StyledHeader, {
        className: "m-bottom-1",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.requestSeatModal.reasonInput.header"
        })
      }), /*#__PURE__*/_jsx(UITextArea, {
        value: requestSeatText,
        onChange: setRequestSeatText,
        placeholder: I18n.text('upgrades.requestSeatModal.reasonInput.placeholder')
      })]
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        className: "m-left-3",
        use: "primary",
        onClick: handleConfirm,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `upgrades.adminModal.${modalType}.button`
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "secondary",
        onClick: () => onClose(),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.confirmationModal.cancel"
        })
      })]
    })]
  });
};